import createNamespaceContext from './helper/createNamespaceContext';
export const PEOPLE_TEAMS_CONTEXT = 'peopleTeamsCtx';
export const PeopleTeamsAnalyticsContext = createNamespaceContext(PEOPLE_TEAMS_CONTEXT, 'PeopleTeamsAnalyticsContext');